import React from 'react'
import Navbar from '../components/home/Navbar'
import Hero from '../components/home/Hero'
import Features from '../components/home/Features'
import Integrations from '../components/home/Integrations'
import Trust from '../components/home/Trust'
import logo from '../assets/logo.png'

const Home: React.FC = () => {
  return (
    <div className='bg-background font-sans text-foreground selection:bg-primary/30 selection:text-primary'>
      <Navbar />
      <main>
        <Hero />
        <Trust />
        <Features />
        <Integrations />
      </main>

      <footer className='bg-background border-t border-border py-12'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4'>
          <div className='flex items-center gap-2'>
            <img
              src={logo}
              alt='ClickVoltz Logo'
              className='h-6 w-auto object-contain rounded-md'
            />
            <span className='font-bold text-lg tracking-tight'>ClickVoltz</span>
          </div>
          <p className='text-sm text-muted-foreground'>
            © {new Date().getFullYear()} ClickVoltz Inc. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Home
